module.exports = __webpack_public_path__ + "img/r2-ur3.1e23a394.jpg";